import React, { useState, useContext } from 'react';
import './style.scss';
import { FormControl, MenuItem, Select } from '@mui/material';
import clsx from 'clsx';
import { SearchContext } from '../context/SearchContext';

/***Component***/
const PaginationComponent = (props) => {
  const {
    indexName,
    pagination,
    setPagination,
    language,
    templateName,
    pageSize,
    facetOn,
    helpers,
    inputSearchRef,
    currentCategory,
    getSearchResultsWithoutSettingTotal,
  } = useContext(SearchContext);

  const [dropdownOpened, setDropdownOpened] = useState(false);
  const pageSizes = props?.pageSizes;
  const shouldRenderItemsPerPage = Array.isArray(pageSizes) && pageSizes?.length > 0;
  const t = props?.t;
  const shouldRenderPageSizes = Array.isArray(pageSizes) && pageSizes.length > 0;
  const showItemsPerPage = props?.showItemsPerPage;

  const handleNext = () => {
    if (!!pagination?.pagesTotalNumber) {
      if (pagination?.currentPage < pagination?.pagesTotalNumber) {
        let newPagination = {
          ...pagination,
          currentPage: pagination?.currentPage + 1,
          hasPrevious: true,
          hasNext:
            pagination?.currentPage + 1 < pagination?.pagesTotalNumber &&
            pagination?.pagesTotalNumber > 1,
        };

        helpers({
          getSearchResultsWithoutSettingTotal,
          indexName,
          templateName,
          language,
          pagination: newPagination,
          keyword: inputSearchRef?.current?.value,
          hasPagination: true,
          facetOn,
          pageSize: pageSize?.value,
          pageSection: currentCategory !== t('All') ? currentCategory : '',
        });

        setPagination(newPagination);
      }
    }
  };
  const handlePrevious = () => {
    if (!!pagination?.pagesTotalNumber) {
      if (pagination?.currentPage > 1) {
        //update count to reload states

        let newPagination = {
          ...pagination,
          currentPage: pagination?.currentPage - 1,
          hasNext: true,
          hasPrevious: pagination?.currentPage === 2 ? false : true,
        };

        helpers({
          getSearchResultsWithoutSettingTotal,
          indexName,
          templateName,
          language,
          pagination: newPagination,
          keyword: inputSearchRef?.current?.value,
          hasPagination: true,
          facetOn,
          pageSize: pageSize?.value,
          pageSection: currentCategory !== t('All') ? currentCategory : '',
        });
        setPagination(newPagination);
      }
    }
  };

  return (
    shouldRenderPageSizes && (
      <div className="generic-pagination flex-it flex-justify-end">
        <div className="paging-controls flex-it flex-align-item-center">
          <div
            className={clsx(
              'paging-control flex-it flex-align-item-center',
              showItemsPerPage ? '' : 'hide'
            )}
          >
            <div className="text text--font"> {!!t && t('itemsPerPage')}</div>
            <div className={clsx('select', dropdownOpened ? 'open' : '')}>
              <FormControl
                className="form-controle"
                margin="none"
                padding="none"
                sx={{ maxWidth: 63, h: 32, p: 0, m: 0 }}
              >
                <span className="arrow-select-wrap flex-it flex-align-item-center">
                  <img
                    alt='arrow'
                    className="arrow-select show-on-open"
                    src={'/-/jssmedia/Project/FAB2/shared/images/icon_pagination-angledown.svg'}
                  />
                  <img
                    alt='arrow'
                    className="arrow-select show-on-close"
                    src={'/-/jssmedia/Project/FAB2/shared/images/icon_pagination-angledown.svg'}
                  />
                </span>

                <Select
                  onOpen={() => setDropdownOpened(true)}
                  onClose={() => setDropdownOpened(false)}
                  onChange={props?.onChange}
                  variant="standard"
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  defaultValue={pagination?.itemsPerPage}
                  value={pagination?.itemsPerPage}
                >
                  {shouldRenderItemsPerPage &&
                    pageSizes?.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item?.fields?.DropdownValue.value}>
                          {item?.fields?.DropdownText.value}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="paging-control flex-it flex-align-item-center">
            <div className="text text--font"> {!!t && t('Page')}</div>
            <div className="case case--font flex-it flex-align-item-center flex-justify-center">
              {pagination?.currentPage}
            </div>
            {(!!pagination?.pagesTotalNumber && (
              <div className="text text--font flex-it flex-align-item-center">
                {!!t && t('Of')}{' '}
                {pagination?.pagesTotalNumber === 0 ? 1 : pagination?.pagesTotalNumber}
              </div>
            )) || (
                <div className="text text--font flex-it flex-align-item-center">
                  {!!t && t('Of')}
                  {' 1'}
                </div>
              )}
          </div>
          <div className="paging-control buttons-control flex-it flex-align-item-center">
            <div
              onClick={handlePrevious}
              className={clsx(
                'paging-button case flex-it flex-align-item-center flex-justify-center',
                pagination?.hasPrevious ? '' : 'disabled'
              )}
            >
              <img
                alt='arrow'
                className="arrow-left"
                src={'/-/jssmedia/Project/FAB2/shared/images/icon_pagination-arrow.svg'}
              />
            </div>
            <div
              onClick={handleNext}
              className={clsx(
                'paging-button case flex-it flex-align-item-center flex-justify-center',
                pagination?.hasNext ? '' : 'disabled'
              )}
            >
              <img
                alt='arrow'
                className="arrow-right"
                src={'/-/jssmedia/Project/FAB2/shared/images/icon_pagination-arrow.svg'}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default PaginationComponent;
